export const HEADER_STYLE = `
.data-table-header {
    min-height: 25px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.title {
    display: block;
    margin: 5px 0 0 5px;
    font-size: 30px;
    color: #00334e;
    font-weight: 600;
    text-decoration: underline;
    z-index: 900;
    background-color: #fff;
    text-align: left;
}
.button-panel button {
    outline: none !important;
}

.column-selector-wrapper {
    position: relative;
}
.column-selector-box {
    width: 150px;
    padding: 10px;
    border: 1px solid #cecece;
    z-index: 1060;
    background-color: #fff;
    overflow-y: auto;
    max-height: 200px;
    box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.2);
    position: absolute;
    right: 0;
    top: 5px;
}
.column-selector-box .checkbox {
    margin-bottom: 4px;
    padding-left: 15px;
}
.column-selector-fixed-column {
    font-style: italic;
}

[type="checkbox"]:checked {
    position: absolute;
    opacity: 1;
    pointer-events: none;
    left: 24px;
}

[type="checkbox"] {
    position: absolute;
    opacity: 1;
    pointer-events: none;
    left: 24px;
}

span {
    padding-left:25px;
    display: block;
    text-align:left;
}

`;


// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/node_modules/angular-4-data-table/src/components/header.style.ts